import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/shared/PublicLayout";
import { SEOHead } from "@/components/shared/SEOHead";
import { BookCallButton } from "@/components/shared/BookCallButton";
import { AwardsSection } from "@/components/shared/AwardsSection";
import { Store, Zap, MapPin, Headphones } from "lucide-react";

const PERKS = [
  [Zap, "Open faster", "Skip the long search and build-out. Step into a store that's already set up for Total Wireless."],
  [MapPin, "Several states", "We have stores ready to go in several states, and new ones become available regularly."],
  [Store, "Built for Total Wireless", "Fixtures, signage and layout designed for a professional Total Wireless store."],
  [Headphones, "Full support", "Training, launch marketing and ongoing field support, plus live sales tracking in your dealer portal."],
];

export default function ReadyToGoStoresPage() {
  return (
    <PublicLayout>
      <SEOHead pageSlug="ready-to-go-stores" fallback={{
        meta_title: "Ready-to-Go Total Wireless Stores | Prime Media Wireless",
        meta_description: "Become a Total Wireless dealer faster with a ready-to-go store. Prime Media Wireless has Total Wireless stores ready in several states. Book a free call.",
      }} />
      <section className="bg-navy py-20" data-testid="ready-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <p className="label-style text-teal mb-4">Pre-built store program</p>
          <h1 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-6 leading-tight">Ready-to-Go Total Wireless Stores</h1>
          <p className="text-slate-300 text-base lg:text-lg font-body mb-8">We have stores ready to go in several states, so you can become a Total Wireless dealer without starting from scratch. When you contact us, we'll let you know what's available in your area.</p>
          <BookCallButton label="Ask what's available near me" />
        </div>
      </section>
      <section className="py-16 bg-white" data-testid="ready-perks">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PERKS.map(([Icon, t, d]) => (
            <div key={t} className="rounded-2xl border border-slate-200 p-6">
              <Icon className="w-8 h-8 text-teal mb-4" />
              <h2 className="font-heading font-semibold text-lg text-navy mb-2">{t}</h2>
              <p className="text-sm text-slate-600 font-body">{d}</p>
            </div>
          ))}
        </div>
        <p className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 text-slate-600 font-body">
          Prefer to build your own? Read our guide on <Link to="/how-to-open-a-total-wireless-store" className="text-teal font-semibold hover:underline">how to open a Total Wireless store</Link> or <Link to="/become-dealer#apply" className="text-teal font-semibold hover:underline">apply to become a Total Wireless dealer</Link>.
        </p>
      </section>
      <AwardsSection />
    </PublicLayout>
  );
}
